import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { ParentAuthService } from "./parent-auth.service";

@Injectable({ providedIn: 'root' })
// protects parent routes from users not signed in from the Client Portal
export class ParentGuard {
  constructor(private parentAuthService: ParentAuthService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.parentAuthService.isSignedIn()) {
      return true;
    }

    console.warn(`ParentGuard: '${state.url}' - Parent not signed in`);
    this.router.navigate(['/parent/signin']);
    return false;
  }
}
